import styled from 'styled-components';
import bg_01 from '../../assets/images/bg_01.png';

export const Wrapper = styled.div`
  padding-bottom:0;padding-bottom:env(safe-area-inset-bottom);background:#ffffff;
`;

export const Container = styled.div`
  .list{
    display:flex;align-items:center;padding:.33rem .33rem;
    /* padding:.64rem .45rem 0; */
    .item{
      display:flex;align-items:center;height: .5rem;margin-right:.66rem; 
      /* margin-right:.77rem; */
      i{
        width:.32rem;height:.32rem;background:#D8D8D8;border-radius:50%;margin: .04rem .18rem 0 0; 
        box-sizing:border-box;display:flex;align-items:center;justify-content:center;
      }
      i.active{
        background:#5799FF;
        b{
          width:.16rem;height:.16rem;border-radius:50%;background:#ffffff;display:block;
        }
      }
      span{
        font-size: .34rem;font-weight: 400;flex:1;color: #000000;
      }
    }
  }
`;